import React from 'react';
import './buttons.css'

const WhatsAppButton = ({ phoneNumber, url }) => {
  const message = `Hola, estoy interesado en este artículo: ${url}\n`;

  const handleWhatsAppButtonClick = () => {
    window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <button onClick={handleWhatsAppButtonClick} className="menuItems-btn"> 
     <img src={process.env.PUBLIC_URL+"/img/whatsapp.png"} alt=" WhatsApp"></img>
    WhatsApp</button>
  );
};

export default WhatsAppButton;
